/* eslint-disable no-new */

import { Initializer } from '@frds/utilities/src/scripts/init/Initializer';
import { BreadcrumbButton } from './index';

new Initializer('.${prefix}-breadcrumb__button', [BreadcrumbButton]);
